class PredictiveSearch extends HTMLElement {
  constructor() {
    super()
    this.inputTimer = null
    this.form = this.querySelector('[predictive-search-form]')
    this.input = this.querySelector('[predictive-search-input]')
    this.results = this.querySelector('[predictive-search-results]')
    this.suggestions = this.querySelector('[predictive-search-suggestions]')
    this.mobileNav = this.closest('.header-nav--mobile')

    this.input.addEventListener('input', (event) => {
      this.input.value = event.target.value
      clearTimeout(this.inputTimer)
      this.inputTimer = setTimeout(() => {
        this.search()
      }, 500)
    })
  }

  search = function () {
    console.log(this.input.value.length)
    if (this.input.value.length > 0) {
      this.mobileNav.setAttribute('search-open', '')
      if (this.input.value.length >= 3) {
        fetch(
          `/search/suggest?q=${this.input.value}&resources[type]=product,query,collection&resources[limit_scope]=each&section_id=mobile-predictive-search`,
        )
          .then((res) => {
            if (!res.ok) {
              var error = new Error(res.status)
              console.error(error)
            }
            return res.text()
          })
          .then((text) => {
            var resultsMarkup = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('#shopify-section-mobile-predictive-search').innerHTML

            this.results.innerHTML = resultsMarkup
            this.suggestions.style.display = 'none'
          })
      } else {
        this.results.innerHTML = ''
        this.suggestions.style.display = 'block'
      }
    } else {
      this.results.innerHTML = ''
      this.suggestions.removeAttribute('style')
      this.mobileNav.removeAttribute('search-open')
    }
  }
}

customElements.define('predictive-search', PredictiveSearch)
